import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentGuiche } from "../../../../../@types/attendance-local-department-guiche";

export type AttendanceLocalDepartmentGuicheCreateData = Pick<
    AttendanceLocalDepartmentGuiche,
    | "ordem"
    | "tipo"
    | "ativo"
    | "setor"
> & {
    user: Array<string>
};

export function useAttendanceLocalDepartmentGuicheCreate() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "department", "guiche", "create"],
        mutationFn: async (data: AttendanceLocalDepartmentGuicheCreateData) => {
            const response = await apisiseci.post<AttendanceLocalDepartmentGuiche>(
                '/cms/guiches_setor/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Guichê criado com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "department", "guiche", "list"],
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
